import { useState, useEffect } from 'react';
import api from '../../utils/api';
import { Users, Package, ShoppingBag, PhoneCall } from 'lucide-react';

export default function AdminDashboard() {
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/admin/stats')
      .then(({ data }) => setStats(data))
      .finally(() => setLoading(false));
  }, []);

  const cards = stats ? [
    { label: 'Total Users',      value: stats.totalUsers,     icon: Users,      color: 'var(--info)',    bg: 'var(--info-soft)'    },
    { label: 'Total Products',   value: stats.totalProducts,  icon: Package,    color: 'var(--accent)',  bg: 'var(--accent-soft)'  },
    { label: 'Active Listings',  value: stats.activeProducts, icon: ShoppingBag,color: 'var(--success)', bg: 'var(--success-soft)' },
    { label: 'Total Contacts',   value: stats.totalContacts,  icon: PhoneCall,  color: 'var(--warning)', bg: 'var(--warning-soft)' },
  ] : [];

  return (
    <div className="fade-in">
      <div className="admin-page-header">
        <div>
          <h2>Dashboard</h2>
          <p className="text-muted" style={{ fontSize: '0.875rem', marginTop: 4 }}>
            Platform overview
          </p>
        </div>
      </div>

      {loading ? (
        <div className="loading-center"><div className="spinner spinner-lg" /></div>
      ) : (
        <div className="admin-stats-grid">
          {cards.map(c => (
            <div key={c.label} className="admin-stat-card card">
              <div className="admin-stat-icon" style={{ background: c.bg, color: c.color }}>
                <c.icon size={19} />
              </div>
              <div className="admin-stat-value">{c.value}</div>
              <div className="admin-stat-label">{c.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}